import MessageBus from '@/ports-frontend/MessageBus';

export async function registerOpen() {
  MessageBus.publishEvent({
    topic: 'wh.common.command.ui.registration.flow.start',
    data: {},
  });
}

export async function registerWatcher({ callback }: { callback: Function }) {
  MessageBus.onSubscribe(
    ({ payload }) => {
      if (payload.state === 'NONE') {
        return callback({
          type: 'REGISTER_MODAL_STATE_CLOSED',
          data: payload,
        });
      }
    },
    ['wh.common.event.ui.registration.flow.state.changed']
  );
}
